import React, { PropsWithChildren } from 'react';

interface MDAndLargerDivProps {
    className?: string
    id?: string
    style?: React.CSSProperties
}

const MDAndLargerDiv = (props: PropsWithChildren<MDAndLargerDivProps>) => {
    const classes = props.className ? `hidden-sm ${props.className}` : 'hidden-sm';
    return <>
        <div
            {...props}
            className={classes}
        >
            {props.children}
        </div>
    </>;
};

export default MDAndLargerDiv;